__turbopack_context__.v({
  "className": "interfont_d6a0f460-module__VKoZKW__className",
  "variable": "interfont_d6a0f460-module__VKoZKW__variable",
});
